import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

/** Prefix shared by the picker and Builder queries, so one invalidation refreshes both. */
export const injection_locations_root_key = ["injection-locations"];

/**
 * Locations for pickers: `available_injection_locations` only returns active locations when the
 * injection attribute is enabled. Builder pages read the base table through
 * `selectInjectionLocationsForBuilder` instead.
 */
async function getInjectionLocations() {
    const { data } = await supabaseClient.from("available_injection_locations").select("*").throwOnError();

    return (data ?? []).flatMap((row) =>
        row.orthopaedic_area != null && row.site != null && row.subsite != null
            ? [
                  {
                      orthopaedic_area: row.orthopaedic_area,
                      site: row.site,
                      subsite: row.subsite,
                      is_public: row.is_public ?? false,
                  },
              ]
            : []
    );
}

export const injection_locations_key = [...injection_locations_root_key, "available"];

export const injectionLocationsQueryOptions = () => {
    return queryOptions({
        queryKey: injection_locations_key,
        queryFn: async () => getInjectionLocations(),
    });
};

export function useInjectionLocationsQuery() {
    return useQuery(injectionLocationsQueryOptions());
}
